
import React,{useState,useRef,memo,useCallback,useEffect} from 'react'
import {getContentPath} from  'system/AssetManager'
import {animateParallax,getAnimationModel,animateIntersect,setInitialAnimIntersectState,setFinalAnimIntersectState} from './CanvasAnimator'
import Globals from 'system/Globals'
// import {onErrorLoad} from 'system/AssetManager'
import gsap, {Power3} from 'gsap'
import { animEventEmitter } from "system/utils/eventEmitter"; 
import InlineSVG from 'react-inlinesvg';

function SVGComponent(props){

    const [inline,setInline] = useState({})
    const [arInline,setArInline] = useState({})
    const [svgString,setSvgString] = useState(null)
    const [imgSrc, setImgSrc] = useState(null)
    const [pngOpacity, setPngOpacity] = useState(1)
     
    let bLoaded=false
    const loadingAnim = useRef();
    const refEle = useRef()
    const refArEle = useRef()
    const refArInnerEle = useRef();
    const refFormat = useRef()
    const refOrigOffset = useRef(0)
    const refAnimationModel = useRef({})
    const refRunAnim = useRef(false);
    
    
    useEffect(()=>{ 
        if (refEle.current) {
            refOrigOffset.current=refEle.current.offsetLeft
        }
        
        if(refFormat.current && refFormat.current.animation && refFormat.current.animation.typeName){
            
            refAnimationModel.current = getAnimationModel(refEle.current,refFormat.current.animation) 
       

            if(props.renderOnly===true){
                setFinalAnimIntersectState(refEle.current,refFormat.current.animation)
            }
        }
        
    },[inline]) // eslint-disable-line react-hooks/exhaustive-deps
    
    const onScroll = useCallback((scrollLeft,scale,pageWidth)=>{
        // console.log(refAnimationModel.current)
        animateParallax(refEle.current,refAnimationModel.current,scrollLeft,pageWidth)
    },[props.model.animation,refEle])// eslint-disable-line react-hooks/exhaustive-deps


    useEffect(() => {
        // console.log('props.pageState', props.pageState)
        
        if (props.pageState === "animPage" && inline && refAnimationModel.current && refAnimationModel.current.animations) {
            console.log('props.pageState', props.pageState)

            animateIntersect(refEle.current,refAnimationModel.current)

        
        }
    }, [props, inline])


    const onIntersect = useCallback((evt,threshold)=>{
        // console.log('SVG onINTERSECT', evt, evt.detail.isIntersecting)
        if(evt.detail.isIntersecting )
        {
            if(evt.detail.intersectionRatio >=threshold)
         
                animateIntersect(refEle.current,refAnimationModel.current)
              

        }
        else if(evt.detail.intersectionRatio <=0.001)
            setInitialAnimIntersectState(refEle.current,refAnimationModel.current)
    },[refEle])

    const onAnim = useCallback((evt,threshold)=>{
        // console.log('SVG onAnim', evt)
        if(evt)
        {
            animateIntersect(refEle.current,refAnimationModel.current)

        }
        else {
            setInitialAnimIntersectState(refEle.current,refAnimationModel.current)
        }
            
    },[refEle])


    

    useEffect(()=>{



        refFormat.current = Globals.instance().getCanvasFormat(props.model.formats,props.format)
        
        // let style ={position:'absolute',transform: 'translateZ(0), perspective: 1000px',willChange:'transform'}
        let imgStyle ={position:'relative',transform: 'translateZ(0), perspective: 1000px', opacity: 0,  'width': '100%', 'height': '100%'};
        let arStyle = {position:'absolute',transform: 'translateZ(0), perspective: 1000px', opacity: 0};

        if (refFormat.current) {
            let resStyle;
            if(refFormat.current.style && !props.pageBkg){ 
                let left = refFormat.current.style.left;
                let top =  refFormat.current.style.top;
                let width = refFormat.current.style.width;
                let objectFit = refFormat.current.style.objectFit;
                
                let opacity = refFormat.current.style.opacity;
                let imgOpacity = refFormat.current.style.opacity;
                let transform = refFormat.current.style.transform;
                // if (refFormat.current.animation && refFormat.current.animation.typeName === "page") {
                //     let opacityAnim = refFormat.current.animation.animations.find(a => a.property === 'opacity');
                //     if (opacityAnim) {
                //         imgOpacity = opacityAnim['start']
                //     }
                //     console.log('hasOpacityAnim', hasOpacityAnimation(refFormat.current), opacityAnim)
                // }
                // console.log('SVG imgOpacity', imgOpacity, refEle.current)
                // console.log('refFormat.current', refFormat.current)
                
                // let width = parseInt(refFormat.current.style.width)/window.innerWidth*100 + "%";
                let height = refFormat.current.style.height;
                
                imgStyle = Object.assign(imgStyle,{'opacity': imgOpacity})
                setPngOpacity(imgOpacity)
                arStyle = Object.assign(arStyle,{'left': left, 'top': top, 'width': width, 'height': height, 'objectFit': objectFit, 'opacity': opacity, 'transform': transform})
                
                // console.log('newtop', width, refFormat.current.style, refEle.current.parentElement.offsetHeight)
                // style = Object.assign(style,refFormat.current.style) 
            } else {
                imgStyle = Object.assign(imgStyle,{'opacity': 1})
                arStyle = Object.assign(imgStyle,{'opacity': 1})
            }

            
            let f = refFormat.current.svg_markup;

            // Fix SVG rendering issues from CMS save:
            // 1. viewBox includes strokeWidthPadding but SVG element dims don't
            // 2. SVG coordinate space may be at CMS zoom scale, not container scale
            // 3. fabric.js can produce Infinity/NaN in transform matrices
            if (f) {
                const wMatch = f.match(/<svg[^>]*\swidth="(\d+(?:\.\d+)?)"/);
                const hMatch = f.match(/<svg[^>]*\sheight="(\d+(?:\.\d+)?)"/);

                // Align viewBox with SVG element dimensions (removes strokeWidthPadding gap)
                if (wMatch && hMatch) {
                    f = f.replace(/viewBox="[^"]*"/, 'viewBox="0 0 ' + wMatch[1] + ' ' + hMatch[1] + '"');
                }

                // Use slice scaling so the SVG fills its container uniformly.
                // When the SVG coordinate space doesn't match the container
                // (e.g. CMS zoom baked into saved dimensions but not SVG coords),
                // "slice" uses the larger scale factor to fill the container,
                // with overflow:visible handling any slight overshoot.
                if (f.match(/preserveAspectRatio="/)) {
                    f = f.replace(/preserveAspectRatio="[^"]*"/, 'preserveAspectRatio="xMinYMin slice"');
                } else {
                    f = f.replace(/<svg\s/, '<svg preserveAspectRatio="xMinYMin slice" ');
                }

                // Fix Infinity/NaN in transform matrices from fabric.js
                if (f.match(/matrix\([^)]*(?:Infinity|NaN)/)) {
                    const svgW = wMatch ? parseFloat(wMatch[1]) : 0;
                    const svgH = hMatch ? parseFloat(hMatch[1]) : 0;
                    f = f.replace(
                        /matrix\([^)]*(?:Infinity|NaN)[^)]*\)/g,
                        'translate(' + (svgW / 2) + ' ' + (svgH / 2) + ')'
                    );
                    console.log('SVG fixed Infinity matrix for component', refFormat.current.component);
                }

                // The <g> transform matrix from fabric.js can have non-uniform
                // scaling (e.g. 2x horizontal, 8x vertical for near-horizontal
                // lines), which inflates stroke width dramatically. Add
                // vector-effect="non-scaling-stroke" to shape elements so the
                // stroke renders at its specified width in CSS pixels.
                f = f.replace(/<(line|path|rect|circle|ellipse|polygon|polyline)\s/g,
                    '<$1 vector-effect="non-scaling-stroke" ');
            }

            if (f) {
                setSvgString(f)
            } else if (refFormat.current.file) {
                setImgSrc(getContentPath(refFormat.current.file))
            }

            //set up animation Type
            if(refFormat.current.animation){

                if(refFormat.current.animation.typeName==='parallax'){
                    props.setScrollCallback(onScroll,props.index)
                    imgStyle.willChange='transform'
                } 
                else if(refFormat.current.animation.typeName==='page'){
                    props.onIntersect(onIntersect, props.index)
                    props.onAnim(onAnim, props.index)
                    imgStyle.willChange='transform, scale, opacity'
                }
            }
           
        }
        // console.log('imgStyle', imgStyle, refFormat.current)
        setInline(imgStyle)
        setArInline(arStyle);
        // animEventEmitter.on("valueChanged", handleValueChange);
       
        
        return ()=>{
            // animEventEmitter.off("valueChanged", handleValueChange);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])


    // useEffect(() => {
    //     if (imgSrc) {
    //         if (refEle.current && !bLoaded) {
    //             refEle.current.src = `${refEle.current.src}?t=${Date.now()}`;
    //             }
    //     }
    // }, [imgSrc])

    function onError(evt){
        console.error("SVG load error"+bLoaded, evt.target.src)
        // onErrorLoad(evt)
        // console.log("src "+evt.target.src)

      
    }
    
    function onLoad(){
        // console.log('onLoad', bLoaded, refFormat.current)
        // loadingAnim.current.pause();
        //down res the image
        if(!bLoaded){

            // gsap.to(refArEle.current, {
            //     backgroundColor: 'transparent',
            //     duration: 0.2,
            //     ease: "power1.inOut"
            // });
            // let opacity = refFormat.current.style.opacity;
            // gsap.to(refEle.current, {opacity: pngOpacity, duration: 0.2, delay: 1});
            gsap.to(refArInnerEle.current, {opacity: 1, duration: 0.2})

            props.onLoad(props.index,refEle.current,props.model)
            bLoaded=true

            if(props.renderOnly===true){
                refAnimationModel.current = getAnimationModel(refEle.current,refFormat.current.animation) 
                setFinalAnimIntersectState(refEle.current,refAnimationModel.current)
            }

         

        }
        
    }


    return ( 
        <span className="svgBox" style={arInline} ref={refArEle} id={refFormat.current && "component_dim_file_svg_" + refFormat.current.component} data-id={refFormat.current && refFormat.current.id} data-fileformat={refFormat.current && refFormat.current.file_format} data-opacity={arInline.opacity}>
        
            {refFormat.current && svgString && <span className="arBoxInner" ref={refEle} style={inline}><InlineSVG
            src={svgString}
            cacheRequests={true}
            width={"100%"}
            height={"100%"}

            // preProcessor={(code) => code.replace(/fill=".*?"/g, 'fill="' + obj.color + '"')}
            // fetchOptions={{ mode: 'cors', credentials: 'omit' }}
            // onLoad={(svg) => {
            // onSvgLoad("svg_p_" + obj.id, obj.start_date_predicted)
            // }}
            onLoad={() => onLoad()}
            onError={(error) => console.log(error.message)}

            /></span>}
            {refFormat.current && imgSrc && <span className="arBoxInner" ref={refEle} style={inline}><img
            src={imgSrc}
            draggable="false"
            width={"100%"}
            height={"100%"}
            alt=""
            onLoad={() => onLoad()}
            onError={(evt) => onError(evt)}
            /></span>}
        </span>    
        
            
    )

}

const SVG = memo(SVGComponent, (prev,next)=>{  return prev.imgSrc === next.imgSr })
export  {SVG}
    // <span dangerouslySetInnerHTML={{__html: svgString}} />